import React from 'react';
export function Team() {
  const team = [{
    name: 'Carlos Roberto Xot',
    role: 'Socio Mayor',
    experience: 'Master en análisis financiero y crediticio.',
    skills: 'Análisis Financiero, Análisis Crediticio',
    education: 'Licenciatura como Contador Público y Auditor, Estudiante de Maestría en Administración Financiera',
    image: 'https://via.placeholder.com/300x300/9333EA/FFFFFF?text=CX'
  }, {
    name: 'Kevin Santos',
    role: 'Socio Mayor',
    experience: 'Contador general con experiencia en empresas de compra-venta de bienes y prestación de servicios, finanzas y presupuestos, desarrollo inmobiliario, impuestos, asesoría fiscal.',
    skills: 'Odoo, Advantage, Excel',
    education: 'Estudios universitarios avanzados de CPA',
    image: 'https://via.placeholder.com/300x300/9333EA/FFFFFF?text=KS'
  }, {
    name: 'Jorge Antuche',
    role: 'Socio Mayor',
    experience: 'Contador general con larga carrera profesional y experiencia de muchos años, basto conocimiento en impuestos y consultoría financiera y fiscal.',
    skills: 'Odoo, Excel',
    education: 'Pensum cerrado de CPA',
    image: 'https://via.placeholder.com/300x300/7C3AED/FFFFFF?text=JA'
  }, {
    name: 'Cristian Maldonado',
    role: 'Socio Medio',
    experience: 'Contador junior con experiencia en empresas de compra-venta de bienes y prestación de servicios, finanzas y presupuestos, desarrollo inmobiliario, constructoras.',
    skills: 'Odoo, SAP, Excel',
    education: 'Estudios avanzados de CPA',
    image: 'https://via.placeholder.com/300x300/6366F1/FFFFFF?text=CM'
  }, {
    name: 'Amilcar Cun',
    role: 'Socio Junior en Crecimiento Potencial',
    experience: 'Estudiante de Administración con gran potencial de desarrollo.',
    skills: 'En formación',
    education: 'Estudiante de Administración',
    image: 'https://via.placeholder.com/300x300/8B5CF6/FFFFFF?text=AC'
  }, {
    name: 'Alexis Juárez',
    role: 'Socio Junior en Crecimiento Potencial',
    experience: 'Estudiante de Administración con gran potencial de desarrollo.',
    skills: 'En formación',
    education: 'Estudiante de Administración',
    image: 'https://via.placeholder.com/300x300/A78BFA/FFFFFF?text=AJ'
  }];
  return <section id="equipo" className="py-20 bg-gray-50 dark:bg-gray-800" data-id="element-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <div className="text-center mb-16" data-id="element-302">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-303">
            Nuestro Equipo
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400" data-id="element-304">
            Profesionales comprometidos con tu éxito financiero
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-305">
          {team.map((member, index) => <div key={index} className="group bg-white dark:bg-gray-900 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden" data-id="element-306">
              <div className="relative overflow-hidden" data-id="element-307">
                <img src={member.image} alt={member.name} className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300" data-id="element-308" />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-309"></div>
              </div>

              <div className="p-6" data-id="element-310">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-311">
                  {member.name}
                </h3>
                <p className="text-purple-600 dark:text-purple-400 font-semibold mb-4" data-id="element-312">
                  {member.role}
                </p>
                <p className="text-gray-700 dark:text-gray-300 mb-3 text-sm" data-id="element-313">
                  {member.experience}
                </p>
                <div className="space-y-2" data-id="element-314">
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-315">
                    <span className="font-semibold" data-id="element-316">Habilidades:</span>{' '}
                    {member.skills}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-317">
                    <span className="font-semibold" data-id="element-318">Educación:</span>{' '}
                    {member.education}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}